import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';

import { SelectItem } from 'primeng/primeng';

import { Filter } from '../../shared/filter';
import { HttpErrorHandler } from '../../shared/http-error-handler';

import { Ship } from '../../_models/ship';
import { ShipType } from '../../_models/ship-type';
import { ShipService } from '../../_services/ship.service';

import { Specie } from '../../_models/specie';
import { SpecieService } from '../../_services/specie.service';

import { CaptureAggregateFilter } from '../../_models/capture-aggregate';
import { Profile } from '../../_models/profile';

@Component({
  selector: 'app-capture-filter',
  templateUrl: './capture-filter.component.html',
  styleUrls: ['./capture-filter.component.css'],
})
export class CaptureFilterComponent extends Filter implements OnInit {
  @Input() filterParams: any[];
  @Input() loading: boolean;
  @Output() onApplyFilter = new EventEmitter<string>();
  profile: Profile;

  form: FormGroup;
  filter: CaptureAggregateFilter;

  ships: SelectItem[];
  selectedShips: Ship[];
  shipTypes: ShipType[];
  selectedShipType: ShipType;
  species: SelectItem[] = [];
  selectedSpecies: Specie[];
  startDate: Date;
  endDate: Date;
  dataFromType: any = { label: 'DEA', value: 'dea' };
  dataFromTypes: any[] = [
    { label: 'DEA', value: 'dea' },
    { label: 'IMPORTADAS', value: 'imports' },
  ];

  constructor(
    private fb: FormBuilder,
    private shipService: ShipService,
    private specieService: SpecieService,
    private router: Router,
    private httpErrorHandler: HttpErrorHandler
  ) {
    super();
    this.profile = Profile.apiMap(JSON.parse(localStorage.getItem('profile')));
    this.form = fb.group({
      code: [''],
      specie: [''],
      ship: [''],
      ship_type: [''],
      start_date: [''],
      end_date: [''],
      data_type: [''],
    });
  }

  ngOnInit() {
    this.filter = new CaptureAggregateFilter(this.filterParams);

    if (this.filter.start_date) {
      this.startDate = new Date(this.filter.start_date);
    }

    if (this.filter.end_date) {
      this.endDate = new Date(this.filter.end_date);
    }

    this.getShips();
    this.getSpecies();
    this.getShipTypes();
  }

  getShips() {
    this.shipService.list(1, 1000, '', '').subscribe(
      (response) => {
        this.ships = this.parseDropdownResults(response.results, new Ship(), 'name', false);
        this.selectedShips = this.selectMultipleDropdownItems(response.results, this.filter.ship);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  getSpecies() {
    this.specieService.get_species_association().subscribe(
      (response) => {
        this.species = this.parseDropdownResults(response, new Specie(), '_label', false);
        this.selectedSpecies = this.selectMultipleDropdownItems(response, this.filter.specie);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }
  getShipTypes() {
    this.shipService.getTypes().subscribe(
      (data) => {
        const shipTypes = ShipType.generateCollectionFromApi(data['actions']['POST']['type']['choices']);
        this.shipTypes = this.parseDropdownResults(shipTypes, new ShipType(), 'display_name');

        this.selectedShipType = this.selectDropdownItem(shipTypes, this.filter.ship_type);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }
  onSubmit(event = null) {
    if (event) {
      event.preventDefault();
    }
    this.filter.reset();

    this.filter.specie = [];
    if (this.selectedSpecies) {
      this.filter.specie = this.selectedSpecies;
    }

    this.filter.ship = [];
    if (this.selectedShips) {
      this.filter.ship = this.selectedShips;
    }

    if (this.selectedShipType) {
      this.filter.ship_type = this.selectedShipType['value'];
    }

    if (this.startDate) {
      this.startDate.setHours(23);
      this.filter.start_date = this.startDate.toISOString().substring(0, 10);
    }

    if (this.endDate) {
      this.endDate.setHours(23);
      this.filter.end_date = this.endDate.toISOString().substring(0, 10);
    }
    if (this.dataFromType) {
      this.filter.data_type = this.dataFromType['value'];
    }

    if (this.filterParams['o'] !== undefined) {
      this.filter['o'] = this.filterParams['o'];
    }

    this.router.navigate(['/captures', CaptureAggregateFilter.serializeRouterParams(this.filter)]);
  }
}



// WEBPACK FOOTER //
// ./src/app/captures/capture-filter/capture-filter.component.ts